import React from "react";

function MobileMenuHamburger(props) {
  return (
    <svg
      width="21"
      height="16"
      viewBox="0 0 21 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 1H21"
        stroke="#1F2022"
        style={{
          stroke: "#1F2022",
          stroke: "color(display-p3 0.1216 0.1255 0.1333)",
          strokeOpacity: "1",
        }}
      />
      <path
        d="M0 8H21"
        stroke="#1F2022"
        style={{
          stroke: "#1F2022",
          stroke: "color(display-p3 0.1216 0.1255 0.1333)",
          strokeOpacity: "1",
        }}
      />
      <path
        d="M0 15H21"
        stroke="#1F2022"
        style={{
          stroke: "#1F2022",
          stroke: "color(display-p3 0.1216 0.1255 0.1333)",
          strokeOpacity: "1",
        }}
      />
    </svg>
  );
}

export default MobileMenuHamburger;
